import React from "react";

// Shared utilities
import { 
    OmniIconComponent, OmniTooltipNextComponent,OmniCheckboxComponent
} from "../../../../shared/components/omni-components";
import { 
    Utils,
} from "../../../../shared";
export class MergeCampaignsPanel extends React.Component {
    nodeRef = [];
    holdDragItems = {};
    dragItems = [];
    constructor(props) {
        super(props);
        this.state = this.defaultState;
        this.dragItems = props.unMapCampaign || [];
        this.dragItems.map((item) => {
            item.isChecked = false;
        })
    }

    // Default state for the component
    defaultState = {
        selectedUnmapCampaign: [],
        selectedUnmapCampaignIndex: [],
    }

    /**
     * React lifecycle method called after the component is mounted.
     * Initializes state variables based on the parentCampaign and unMapCampaign props.
     */
    componentDidUpdate(prevProps) {
        if (prevProps.unMapCampaign.length !== this.props.unMapCampaign.length) {
            this.dragItems = this.props.unMapCampaign || [];
                this.dragItems.map((item) => {
                item.isChecked = false;
            })
            this.setState({
                selectedUnmapCampaign: [],
                selectedUnmapCampaignIndex: [],
            });
        }
    }

    /**
     * drag start is function will send selected or draged unmapcampagin to transfer event in json format
     * if checkbox is selected then it will send array of ummapcampagin
     * if checkbox not selected then send on one camapgin in side array
     * Index sending to delete already merged unmapcampagin from list.
     * @param {object} event 
     * @param {object} item 
     * @param {number} index 
     */
    dragStart = (event,item,index) => {
        let listItems = [];
        let listItemsIndex  = [];
        let selectedUnmapCampaign = this.state.selectedUnmapCampaign;
        if(selectedUnmapCampaign.length > 0){
            listItems = selectedUnmapCampaign;
            listItemsIndex = this.state.selectedUnmapCampaignIndex;
        }else{
            listItems = [item];
            listItemsIndex = [index];
        }
        
        this.holdDragItems = {
            items : listItems,
            indexs : listItemsIndex
        };
        const dragData = {
            items: listItems,
            indexs : listItemsIndex
        }
        const jsonData = JSON.stringify(dragData);

        event.dataTransfer.setData("application/json", jsonData);
    };

    /**
     * create content from unmapp campagin 
     * @returns html of drag cards
     */
    createDragableContent = () => {
        return  this.dragItems.map((item, index)=>{
                    let budget = 0;
                    // item.isChecked = false;
                    if(this.props?.systemParametersData?.data?.isLocal && item?.local_currency_name){
                        budget = Utils.getLocalCurrency(item?.local_currency_name, item?.campaign_total_budget);
                    }else{
                        budget = Utils.getLocalCurrency('USD', item?.campaign_total_budget);
                    }
                    const channel = item?.media_attributes?.channels?.map(channel => channel.channel_name).toString().replaceAll(',',", ");
                    return (
                        <div className="mapping-item-card-container inner-col factory-panel" onDragStart={(e) => this.dragStart(e,item,index)} draggable="true" key={index}>
                                <div className="mapping-item-card">
                                    <div className="mapping-left">
                                        <div className="drag-handle" title="Drag">
                                            <OmniIconComponent className="is-size-2" icon-id="omni:interactive:reorder"></OmniIconComponent>
                                        </div>
                                        <div className="channel-icon">
                                            {/* <OmniIconComponent className="is-size-2" icon-id={'omni:informative:assets'} /> */}
                                            <OmniCheckboxComponent id={`unmapCampaign-${index}`} name={`unmapCampaign-${index}`}
                                                checked={item.isChecked}
                                                onCheckboxChange={(event) => this.onDataChange(event, item,index)}>
                                            </OmniCheckboxComponent>
                                        </div>
                                        <div className="channel-icon" onClick={()=>this.openAndCloseModal('open',item)}>
                                            <OmniIconComponent className="is-size-2" icon-id="omni:informative:error" ></OmniIconComponent>
                                        </div>
                                    </div>
                                    <div className="mapping-center">
                                        <div className="mapping-title">{item.campaign_name}</div>
                                        <div className="mapping-meta">{item.client_code}|{item.client_name}</div>
                                        <div className="mapping-meta">{item.start_date ? Utils.formatDateObject(item.start_date) : ''} {item.end_date ? ' - ' + Utils.formatDateObject(item.end_date) : ''}</div>
                                        <div className="mapping-meta">{channel}</div>
                                    </div>
                                    <div className="mapping-right">
                                        <div className="mapping-synthetic">{item.synthetic_id}</div>
                                        <div className="mapping-price ordered">{budget}</div>
                                        {/* <div className="mapping-price planned">{}</div> */}
                                    </div>
                                </div>
                        </div>
                    )
                });
    }

    /**
     * user check or uncheck box the it hold checked unmapcampaign to send selected campagin
     * @param {object} event 
     * @param {object} item 
     * @param {number} index 
     */
    onDataChange = (event, item,index) => {
        this.dragItems[index].isChecked = event.target.checked;
        let selectedUnmapCampaign = structuredClone(this.state.selectedUnmapCampaign);
        let selectedUnmapCampaignIndex = structuredClone(this.state.selectedUnmapCampaignIndex);
        if(event.target.checked){
            selectedUnmapCampaign.push(item);
            selectedUnmapCampaignIndex.push(index);
        }else{
            let unmapCampaignIndex = selectedUnmapCampaign.findIndex(campaign => campaign.synthetic_id === item.synthetic_id);
            if(unmapCampaignIndex !== -1){
                selectedUnmapCampaign.splice(unmapCampaignIndex, 1);
                selectedUnmapCampaignIndex.splice(unmapCampaignIndex, 1);
            }
        }
        this.setState({selectedUnmapCampaign, selectedUnmapCampaignIndex});
    }

    /**
     * function use to close popu modal of campagin that appare when click on info ican
     * @param {string} status 
     * @param {object} item 
     */
    openAndCloseModal = (status,item = {}) => {
        const modal = document.getElementById('mappingModal');
        if (modal) {
            if(status === 'close'){
                modal.close(); 
            }else{
                this.setState({ modalValues: item });
                modal.showModal();
            }
        }
    }

    render() {
        return (
            <>
                {this.props.isMappingTable && <div className="mergecampaign-container">
                    <div className="mapping-header">
                        <p>Mapping</p>
                        <div className="modal-close-icon"  onClick={() => this.props.setMappingTable(false)}>
                            <OmniIconComponent className="is-size-1" icon-id="omni:interactive:close"></OmniIconComponent>
                        </div>
                    </div>
                    <hr />
                    <div className="mapping-subheader">
                        <div className="subheader-text">
                            <span>{this.dragItems.length}</span>
                            <p>Campaign Orders</p>
                        </div>
                        <div className="modal-close-icon">
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:interactive:search"></OmniIconComponent> */}
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:interactive:funnel"></OmniIconComponent> */}
                            {/* <OmniIconComponent className="is-size-1 subheader-icon" icon-id="omni:informative:menu"></OmniIconComponent> */}
                        </div>
                    </div>
                    <div className="drag-container">
                        { this.createDragableContent()}
                    </div>
                    <omni-modal id="mappingModal">
                        <div slot="header">
                            <div className="mapping-header mapping-modal-header">
                                <p>Details</p>
                                <div className="modal-close-icon"  onClick={() => this.openAndCloseModal('close')}>
                                    <OmniIconComponent className="is-size-1" icon-id="omni:interactive:close"></OmniIconComponent>
                                </div>
                            </div>
                        </div>
                        <div className="modal-details" style={{ padding: '18px 20px' }}>
                            {/* Two-column label/value layout */}
                            {(() => {
                                const v = this.state?.modalValues || {};
                                const isLocal = this.props?.systemParametersData?.data?.isLocal;
                                const formatCurrency = (amount) => {
                                    if (isLocal && v?.local_currency_name) return Utils.getLocalCurrency(v.local_currency_name, amount || 0);
                                    return Utils.getLocalCurrency('USD', amount || 0);
                                }
                                const channels = v?.media_attributes?.channels?.map(c => c.channel_name).join(', ');
                                const dateRange = v?.start_date || v?.end_date ? `${v.start_date ? Utils.formatDateObject(v.start_date) : ''}${v.end_date ? ' - ' + Utils.formatDateObject(v.end_date) : ''}` : (v.campaign_date_range || '');

                                return (
                                    <div style={{ display: 'grid', gridTemplateColumns: '180px 1fr', rowGap: '12px', columnGap: '18px', alignItems: 'start' }}>
                                        <div style={{ color: '#6b7280' }}>Source:</div>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                            <OmniIconComponent icon-id={"omni:object:campaign"} className="is-size-3" ></OmniIconComponent>
                                            <span>{v.source}</span>
                                        </div>

                                        <div style={{ color: '#6b7280' }}>Name:</div>
                                        <div style={{ color: '#111827', fontWeight: 500 }}>{v.campaign_name || v.name || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Prisma ID:</div>
                                        <div style={{ color: '#111827' }}>{v.synthetic_id || v.prisma_id || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Date Range:</div>
                                        <div style={{ color: '#111827' }}>{dateRange || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Channel(s):</div>
                                        <div style={{ color: '#111827' }}>{channels || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Ordered:</div>
                                        <div style={{ color: '#111827' }}>{formatCurrency(v.ordered_budget || v.ordered || v.ordered_amount)}</div>

                                        <div style={{ color: '#6b7280' }}>Planned:</div>
                                        <div style={{ color: '#111827' }}>{formatCurrency(v.planned_budget || v.planned || v.campaign_total_budget)}</div>

                                        <div style={{ color: '#6b7280' }}>Client Code:</div>
                                        <div style={{ color: '#111827' }}>{v.client_code || v.client || '-'}</div>

                                        <div style={{ color: '#6b7280' }}>Product Code:</div>
                                        <div style={{ color: '#111827' }}>{v.product_code || v.product || '-'}</div>
                                    </div>
                                )
                            })()}
                        </div>
                    </omni-modal>
                </div>
                }       
            </>
        );
    }

}